import { useTranslations } from 'next-intl';
import { useEffect, useState } from 'react';
import { Input } from '@/app/components/ui/input';
import { cn, reportEvent } from '@/app/utils';

export const InviteCodeInput = ({
  handleValidateInviteCode,
  inviteCodeError,
  inviteCode,
}: {
  handleValidateInviteCode: (inviteCode: string) => void;
  inviteCodeError: string;
  inviteCode: string;
}) => {
  const t = useTranslations();
  const [localInviteCode, setLocalInviteCode] = useState(inviteCode);
  useEffect(() => {
    if (inviteCode !== localInviteCode) {
      setLocalInviteCode(inviteCode);
    }
  }, [inviteCode]);
  return (
    <div className="w-full">
      <Input
        placeholder={t('login.inviteCode.placeholder')}
        className={cn(
          'h-12 w-full rounded-12 border border-system-white12 bg-system-white08 py-[10px] text-sm text-system-white placeholder:text-system-white64',
          inviteCodeError && 'border-system-error',
        )}
        value={localInviteCode}
        onChange={(e) => {
          setLocalInviteCode(e.target.value);
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            handleValidateInviteCode(localInviteCode);
            reportEvent('invi_element_click', {
              element_name: 'invi_confirm',
            });
          }
        }}
        onBlur={() => {
          handleValidateInviteCode(localInviteCode);
          reportEvent('invi_element_click', {
            element_name: 'invi_confirm',
          });
        }}
      />
      {inviteCodeError && <p className="mt-2 text-left text-system-error text-xs">{inviteCodeError}</p>}
    </div>
  );
};
